import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

export default function Journal() {
  const { lang } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog", { params: { lang } }).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, [lang]);
  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-32">
      <div className="overline text-[#D4AF37]">{lang === "fr" ? "Journal" : "Journal"}</div>
      <h1 className="font-serif font-light text-5xl md:text-7xl text-[#0A1128] mt-4">
        {lang === "fr" ? "Récits & itinéraires." : "Stories & itineraries."}
      </h1>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="journal-grid">
        {posts.map((p) => (
          <Link key={p.slug + p.language} to={`/journal/${p.slug}`} className="group hover-scale" data-testid={`post-${p.slug}`}>
            <div className="overflow-hidden">
              <img src={p.cover} alt={p.title} className="w-full h-[360px] object-cover" />
            </div>
            <div className="mt-5">
              <div className="overline text-[#D4AF37]">{p.author}</div>
              <h2 className="font-serif text-2xl text-[#0A1128] mt-2 group-hover:text-[#D4AF37] transition-colors">{p.title}</h2>
              <p className="text-sm text-[#0A1128]/70 mt-3 leading-relaxed">{p.excerpt}</p>
            </div>
          </Link>
        ))}
        {posts.length === 0 && <p className="text-[#0A1128]/60">{lang === "fr" ? "Bientôt disponible." : "Coming soon."}</p>}
      </div>
    </div>
  );
}
